/* eslint-disable max-len */
/* eslint-disable react/button-has-type */
import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'emotion';
import { defaultStyle } from './style'
import { Icon } from '@maxmilhas/hangar-components-atomic/public'

const ButtonLink = (props) => {
  const { children, onClick, disabled, color, size, buttonStyle, icon, ...rest } = props

  const isIconButton = buttonStyle === 'icon'

  return (
    <a
      disabled={disabled}
      onClick={onClick}
      className={css`${defaultStyle(color, size, buttonStyle, disabled)}`}
      {...rest}
    >
      {!isIconButton ? children : <Icon size="small" name={icon} />}
    </a>
  )
}

ButtonLink.propTypes = {
  /** Recebe uma string que direciona a uma das cores da paleta principal do design system (green, blue, yellow, red) ou um HEX de cor (#000000). */
  color: PropTypes.string,
  /** Recebe uma string que define o tamanho do botão (small, normal, big), sendo o size normal o default quando nenhum é passado. */
  size: PropTypes.oneOf(['extraSmall', 'small', 'normal', 'big']),
  /** Define o estilo custom do button entre outline, onlyText, onlyTextSecondary. */
  buttonStyle: PropTypes.oneOf(['default', 'icon', 'outline', 'onlyText', 'onlyTextSecondary']),
  /** Elemento children do componente, geralmente o seu texto. */
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  /** Estado disabled do botão */
  disabled: PropTypes.bool,
  /** Função onClick acionada pelo botão */
  onClick: PropTypes.func,
  /** Nome do Icon a ser renderizado puxando da lib no Icomoon */
  icon: PropTypes.string
}

ButtonLink.defaultProps = {
  color: null,
  size: 'normal',
  buttonStyle: 'default',
  children: null,
  onClick: null,
  disabled: false,
  icon: null
}

export default ButtonLink
